<script>
	import { onMount } from 'svelte';
	import { currentUser } from '../utils/utils.js';
	import Dashboard from '../components/Dashboard.svelte';
	export let user = null;
	let mounted = false;

	onMount(() => {
		if (user) {
			$currentUser = user;
		}
		mounted = true;
	});
</script>

{#if mounted}
	<div id="print-area" class="app-container">
		<h1>Reports</h1>
		<Dashboard />
	</div>
{/if}

<style>
	:global(*) {
		box-sizing: border-box;
		margin: 0;
	}
	:global(html, body) {
		width: 100%;
		height: 100%;
		font-family: 'Overpass', sans-serif;
	}
	h1 {
		font-family: 'Chivo', serif;
	}
</style>
